module.exports = __webpack_public_path__ + "img/CodexData.c3bb833d.png";